/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Mastercard: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <rect width='32' height='32' rx='16' fill='black' />
    <path d='M18.8133 21.032H13.1875V10.9688H18.8133V21.032Z' fill='#FF5F00' />
    <path
      d='M13.5487 15.9994C13.5487 13.958 14.509 12.1396 16.0044 10.9678C14.9109 10.1109 13.5307 9.59941 12.0308 9.59941C8.47995 9.59941 5.60156 12.4647 5.60156 15.9994C5.60156 19.5341 8.47995 22.3994 12.0308 22.3994C13.5307 22.3994 14.9109 21.888 16.0044 21.031C14.509 19.8592 13.5487 18.0408 13.5487 15.9994Z'
      fill='#EB001B'
    />
    <path
      d='M26.4032 15.9994C26.4032 19.5341 23.5249 22.3994 19.974 22.3994C18.4741 22.3994 17.094 21.888 16 21.031C17.4958 19.8592 18.4561 18.0408 18.4561 15.9994C18.4561 13.958 17.4958 12.1396 16 10.9678C17.094 10.1109 18.4741 9.59941 19.974 9.59941C23.5249 9.59941 26.4032 12.4647 26.4032 15.9994Z'
      fill='#F79E1B'
    />
  </React.Fragment>
)
